<po-page-default
  p-title="Pedidos"
>
  <po-table *ngIf="!isMobile"
    [p-columns]="columns"
    [p-items]="items"
    p-container="border"
    [p-sort]="true"
    [p-literals]="customLiterals"
    [p-striped]="true"
    (p-expanded)="onExpandDetail($event)"
    [p-striped]="true"
    [p-actions-right]="true"
   >
  </po-table>

  <app-card *ngIf="isMobile"
    [myData]="items"
    (carregarItensPedido)="onCarregarItensCard($event)"
    (downloadPDF)="downloadPDFCard($event)"
    >
  </app-card>

  <div class="po-row totals-minimal-row po-mt-4 po-mb-4">
    <div class="po-md-3 po-sm-12 total-block">
      <span class="total-label">Bruto</span>
      <span class="total-amount">{{
        (totals.grossValue | currency: "BRL") ?? "R$0,00"
      }}</span>
    </div>

    <div class="po-md-3 po-sm-12 total-block">
      <span class="total-label">Abatimentos</span>
      <span class="total-amount green-accent">- {{
        (totals.discountValue | currency: "BRL") ?? "R$0,00"
      }}</span>
    </div>

    <div class="po-md-3 po-sm-12 total-block">
      <span class="total-label">Frete</span>
      <span class="total-amount negative">+ {{
        (totals.freightValue | currency: "BRL") ?? "R$0,00"
      }}</span>
    </div>

    <div class="po-md-3 po-sm-12 total-block total-final">
      <span class="total-label">Pedido</span>
      <span class="total-amount blue-accent">{{
        (totals.totalValue | currency: "BRL") ?? "R$0,00"
      }}</span>
    </div>
  </div>

  <app-pagination
    [pCurrentPage]="currentPage"
    [pTotalItems]="totalItems"
    [pPageSize]="pageSize"
    [pTotalPages]="totalPages"
    (pChangePage)="onPageChange($event.page, $event.pageSize)"
  >
  </app-pagination>    

  <div class="sample-container">
    <po-loading-overlay
      [p-screen-lock]="true"
      [hidden]="isLoadingHidden"
      [p-size]="loadingSize"
      [p-text]="loadingText"
    >
    </po-loading-overlay>
  </div>
  <div class="po-row widget-row"></div>
  <!-- <last-menu-acess></last-menu-acess> -->
</po-page-default>